<template>
  <!-- eslint-disable -->
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 1000 1000">
    <g>
      <path
        :fill="fill"
        fill-rule="nonzero"
        d="M523.8,974.7L871,624.9c0,0,31.4-26.8,31.4-65.3V344.4l-42.3,24.3v116c0,0,2.3,40-47.1,85.9c-45.3,44.6-345.5,347-345.5,347L523.8,974.7L523.8,974.7L523.8,974.7z M621.8,331.2c0,0,69.1-301.5,206.5-305.8c135.8-4.2,164.9,100,161.4,165.5c-4.1,78-80.7,136.6-129.6,145.7c0-39.3,0.2-55.2,0.2-55.2s80-21.6,80.3-92.3c0.2-54.7-29.9-125.7-112.3-116.6c-97.3,10.7-166.6,286-166.6,286l-14.5,14.6L621.8,331.2L621.8,331.2L621.8,331.2z M765.2,175h38.1v298.7c0.9,25.4-29,56.5-29,56.5L332.4,971L10,643.2c0,0,393-393.5,436.5-437.2c30.8-31,50.7-31,50.7-31h230.5L675,309.2l5.6,26c2.2,10.2,1.4,27.6,1.4,27.6c-5.4,22.4-25.4,39-49.3,39c-28,0-51.9-24.1-51.9-52.2c0-14.4,15.9-44.1,40.2-49.1l14.9-49.1c-65.2,13.4-99.8,55.3-99.8,99.4c0,54.1,43.6,98,97.4,98c53.8,0,97.4-43.9,97.4-98c-1.2-19.2-3-22.9-9.4-42.7c-5.3-17.5,26.2-93.1,26.2-93.1L765.2,175L765.2,175z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      default: '#94979B',
      type: String,
    },
  },
};
</script>
